export default "__VITE_ASSET__tO6YCNqQ__"